<script lang="ts" setup>
import { Mailing } from '@/@types'
import { Item } from '@/@types/cart'
import { Card, CardContent } from '@/components/ui/card'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

defineProps<{
    mailing: Mailing
    orderItem: Item
}>()
</script>

<template>
    <div>
        <div>
            <div v-if="mailing && mailing.status === 'ticket_generated'" class="overflow-hidden">
                <Tabs>
                    <div class="flex items-center justify-between overflow-x-auto">
                        <TabsList className="max-w-full">
                            <div class="bg-muted overflow-x-auto rounded-md p-1">
                                <TabsTrigger class="data-[state=active]:bg-white" value="personal-data">
                                    {{ $t('Personal data') }}
                                </TabsTrigger>
                                <TabsTrigger class="data-[state=active]:bg-white" value="professional-data">
                                    {{ $t('Professional Information') }}
                                </TabsTrigger>
                                <TabsTrigger class="data-[state=active]:bg-white" value="address">
                                    {{ $t('Address') }}
                                </TabsTrigger>
                            </div>
                        </TabsList>
                    </div>

                    <Card class="mt-4 border-transparent">
                        <CardContent class="rounded-xl bg-gray-100 pt-6">
                            <TabsContent value="personal-data" class="font-inter">
                                <strong class="text-lg font-semibold">{{ $t('Personal data') }}</strong>
                                <div class="mt-4 grid gap-4 sm:grid-cols-[160px_1fr]">
                                    <p>{{ $t('Full name') }}:</p>
                                    <p class="font-semibold">
                                        {{ mailing?.personal_info?.full_name }}
                                    </p>
                                    <p>{{ $t('CPF') }}:</p>
                                    <p class="font-semibold">
                                        {{ mailing?.personal_info?.cpf }}
                                    </p>
                                    <p>{{ $t('Email') }}:</p>
                                    <p class="font-semibold">
                                        {{ mailing?.email }}
                                    </p>
                                    <p>{{ $t('Badge name') }}:</p>
                                    <p class="font-semibold">
                                        {{ mailing?.badge_name }}
                                    </p>
                                    <p>Linkedin</p>
                                    <p class="font-semibold">
                                        {{ mailing?.personal_info?.linkedin }}
                                    </p>
                                    <p>{{ $t('Phone') }}</p>
                                    <p class="font-semibold">
                                        {{ mailing?.personal_info?.fone }}
                                    </p>
                                </div>
                            </TabsContent>
                            <TabsContent value="professional-data" class="font-inter">
                                <strong class="text-lg font-semibold">{{ $t('Professional Information') }}</strong>

                                <div class="mt-4 grid gap-4 sm:grid-cols-[160px_1fr]">
                                    <p>{{ $t('Company') }}:</p>
                                    <p class="font-semibold">{{ mailing?.company?.name }}</p>
                                    <p>{{ $t('Area') }}:</p>
                                    <p class="font-semibold">
                                        {{ mailing?.company?.area }}
                                    </p>
                                    <p>{{ $t('Sector') }}:</p>
                                    <p class="font-semibold">
                                        {{ mailing?.company?.sector }}
                                    </p>
                                    <p>{{ $t('Ocuppation') }}:</p>
                                    <p class="font-semibold">
                                        {{ mailing?.company?.occupation }}
                                    </p>
                                    <p>{{ $t('Hierarchical level') }}:</p>
                                    <p class="font-semibold">
                                        {{ mailing?.company?.hierarchical_level }}
                                    </p>
                                </div>
                            </TabsContent>
                            <TabsContent value="address" class="font-inter">
                                <strong class="text-lg font-semibold">{{ $t('Address') }}</strong>
                                <div class="mt-4 grid gap-4 sm:grid-cols-[160px_1fr]">
                                    <p>{{ $t('Zipcode') }}:</p>
                                    <p class="font-semibold">
                                        {{ mailing?.personal_info?.zip_code }}
                                    </p>
                                    <p>{{ $t('Country') }}:</p>
                                    <p class="font-semibold">
                                        {{ mailing?.personal_info?.country }}
                                    </p>
                                    <p>{{ $t('Address') }}:</p>
                                    <p class="font-semibold">
                                        {{ mailing?.personal_info?.street }}
                                    </p>
                                    <p>{{ $t('City') }}:</p>
                                    <p class="font-semibold">
                                        {{ mailing?.personal_info?.city }}
                                    </p>
                                    <p>{{ $t('State') }}:</p>
                                    <p class="font-semibold">
                                        {{ mailing?.personal_info?.state }}
                                    </p>
                                    <p>{{ $t('Number') }}</p>
                                    <p class="font-semibold">
                                        {{ mailing?.personal_info?.number }}
                                    </p>
                                </div>
                            </TabsContent>
                        </CardContent>
                    </Card>
                </Tabs>
            </div>
        </div>
    </div>
</template>
